var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.13 14.31C12.4224 14.31 13.47 13.2624 13.47 11.97C13.47 10.6777 12.4224 9.63 11.13 9.63C9.83769 9.63 8.79004 10.6777 8.79004 11.97C8.79004 13.2624 9.83769 14.31 11.13 14.31Z",
    fill: "#FF0031"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7904 10.59C19.8704 9.68001 22.5804 12.71 18.6404 13.44C14.9604 14.11 12.4104 11.34 15.7904 10.59Z",
    fill: "#FF0031"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6497 20.67C11.5497 19.75 10.5897 16.24 12.0697 15.12C14.2097 15.18 15.7997 20.01 14.2197 20.96C13.6997 21.24 13.0697 21.02 12.6497 20.67Z",
    fill: "#FF0031"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5099 3.21998C15.2399 5.24998 14.3699 9.42998 11.5799 8.80998C10.7999 6.78998 11.8299 2.64998 14.5099 3.21998Z",
    fill: "#FF0031"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75985 7.64005C11.6298 12.1501 2.34985 10.5301 3.53985 6.19005C5.04985 5.95005 6.75985 6.49005 7.75985 7.64005Z",
    fill: "#FF0031"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80002 13.59C10.13 12.92 8.13002 16.78 5.80002 17.6C1.76002 19.01 3.75002 14.21 6.80002 13.59Z",
    fill: "#FF0031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.4ecc3893cd1625b635f54e01a7f8c109.svg";
export { ForwardRef as ReactComponent };